import React from 'react'

const PageLinks = ({ block }) => (
  <section className={`block ${block._template} ${block.css_class_name}`}>
    <div className='container'> 
      <div className='row'>
        <div className='col-lg-4'>
          {block.title && ( <h2 dangerouslySetInnerHTML={{__html: block.title}}></h2> )}
          {block.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: block.text}}></div> )}
          {block.image && (
            <img className='card-image is-desktop' src={block.image} alt={block.image_alt_text} title={block.image_alt_text} />
          )}
        </div>

        <div className='col-lg-8'>
          {block.items.map((item, index) => {
            return <div key={index} className={`item`}>
              <h3>
                <a href={item.url}></a>
                {item.icon && (
                  <img src={item.icon} alt={item.title} title={item.title} />
                )}
                {item.title}
              </h3>
            </div>
          })}
        </div>
      </div>
    </div>
  </section>
)

export default PageLinks
